import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  LeftSidebarView,
  ViewBody
} from 'components/Sidebar'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import AddNewLayout from '../../../AddNewLayout'

export class AddDesk extends React.Component {
  static propTypes = {
    isTemplate: PropTypes.bool.isRequired,

    leftSidebar: PropTypes.object.isRequired,
  }

  close = () => {
    this.props.leftSidebar.pop()
  }

  render () {
    const {
      isTemplate
    } = this.props

    return (
      <LeftSidebarView
        title={<FormattedMessage id={isTemplate ? 'DESK_ADD_NEW_TEMPLATE' : 'DESK_ADD_NEW'} />}
      >
        <ViewBody>
          <AddNewLayout
            isTemplate={isTemplate}
            close={this.close}
          />
        </ViewBody>
      </LeftSidebarView>
    )
  }
}

export default withLeftSidebar(AddDesk)
